module.exports = __webpack_public_path__ + "static/media/DesignSmartLogo.94434a7b.svg";